import type { ChartConfig } from '@/components/ui/chart';
import type { HistoryTimeRange, PersonaSortOption, SimulationOutcome } from './types';

export const SIMULATION_OUTCOME_LABELS: Record<SimulationOutcome, string> = {
  completed: 'Completed',
  cancelled: 'Cancelled',
  failed: 'Failed',
};

export const ISSUE_SCORE_THRESHOLD = 70;
export const PERSONA_SORT_LABELS: Record<PersonaSortOption, string> = {
  needs_review: 'Lowest score',
  highest_score: 'Highest score',
  newest: 'Newest',
  name: 'Name',
};
export const ALL_POPULATIONS = '__all__';
export const HISTORY_TIME_RANGES: HistoryTimeRange[] = [7, 30, 90, 365];
export const HISTORY_TIME_RANGE_LABELS: Record<HistoryTimeRange, string> = {
  7: '7D',
  30: '30D',
  90: '90D',
  365: '1Y',
};
export const HISTORY_CHART_CONFIG = {
  score: {
    label: 'Average Score',
    color: 'hsl(var(--primary))',
  },
  run: {
    label: 'Run',
    color: 'hsl(var(--muted-foreground))',
  },
} satisfies ChartConfig;
export const CHART_TOGGLE_BUTTON_CLASS = 'h-6 px-2 text-[11px] font-normal data-[state=on]:bg-background data-[state=on]:text-foreground data-[state=on]:shadow-sm';
